import api from './api';

export const searchApi = {
  // 통합 검색
  searchSummary: async (query) => {
    const response = await api.getPublic(`/search/summary?q=${query}`);
    return response.data;
  },

  // view all 전체 검색
  searchCategory: async (category, query) => {
    const response = await api.getPublic(`/search/${category}/all?q=${query}`);
    return response.data;
  },

  // 앨범 검색
  searchAllAlbums: async (query, category, type) => {
    const response = await api.getPublic(
      `/search/albums/all?q=${query}&category=${category}&type=${type}`,
    );
    return response.data;
  },
};
